'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_EnumSample$package$$anon$6$$anon$10(evaluator$10) {
  this.Lc = null;
  this.Lc = evaluator$10;
}
export { $c_Lsamples_EnumSample$package$$anon$6$$anon$10 as $c_Lsamples_EnumSample$package$$anon$6$$anon$10 };
$p = $c_Lsamples_EnumSample$package$$anon$6$$anon$10.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_EnumSample$package$$anon$6$$anon$10;
/** @constructor */
function $h_Lsamples_EnumSample$package$$anon$6$$anon$10() {
}
export { $h_Lsamples_EnumSample$package$$anon$6$$anon$10 as $h_Lsamples_EnumSample$package$$anon$6$$anon$10 };
$h_Lsamples_EnumSample$package$$anon$6$$anon$10.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.Lc.h();
  return ($j_java$002elang$002e$002dObject.$isInt(v) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_EnumSample$package$$anon$6$$anon$10 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_EnumSample$package$$anon$6$$anon$10, "samples.EnumSample$package$$anon$6$$anon$10", ({
  oW: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_EnumSample$package$$anon$6$$anon$10 as $d_Lsamples_EnumSample$package$$anon$6$$anon$10 };
